import { useLanguage } from "../../context/LanguageContext";
import translations from "../../locals/translations.json";

const UpcomingAuctionSection = () => {
  const { language } = useLanguage();
  const isRTL = language === "ar";

  return (
    <div
      className="flex justify-between items-center mb-4"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <h2 className="text-[25px] md:text-[40px] leading-[40px] font-semibold">
        {translations[language].upcomingAuction.bestCars}{" "}
        <span className="text-primary-dark">
          {translations[language].upcomingAuction.upcoming}
        </span>{" "}
        {translations[language].upcomingAuction.auction}
      </h2>

      <div
        className={`flex items-center font-medium text-[#DE542E] text-[16px] gap-1`}
      >
        <h1>{translations[language].upcomingAuction.viewAll}</h1>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
        >
          <path
            d="M16.5248 0.779351H6.17181C5.92614 0.779351 6.17181 0.533685 6.17181 0.779351C6.17181 1.02502 5.92614 1.72053 6.17181 1.72053H14.6424L0.52475 15.8382C0.351125 16.0118 0.351125 16.6058 0.52475 16.7794C0.411041 16.7794 0.611542 16.8661 0.52475 16.7794C0.638458 16.7794 1.37909 16.8661 1.46593 16.7794L15.5836 2.6617V11.1323C15.5836 11.378 16.279 11.1323 16.5248 11.1323C16.5248 11.378 16.7705 11.1323 16.5248 11.1323V0.779351C16.7704 0.779351 16.5248 0.533685 16.5248 0.779351Z"
            fill="#DE542E"
          />
        </svg>
      </div>
    </div>
  );
};

export default UpcomingAuctionSection;
